import { observable } from "@legendapp/state";
import { useValue } from "@legendapp/state/react";

import { appServer } from "~/api";

interface AuthSessionState {
  token: string | null;
  userId: string | null;
}

const session$ = observable<AuthSessionState>({
  token: null,
  userId: null,
});

export const authSession = {
  clear() {
    appServer.setAccessToken(null);
    session$.token.set(null);
    session$.userId.set(null);
  },
  restore(token: string) {
    appServer.setAccessToken(token);
    session$.token.set(token);
  },
  setAuthenticated(token: string, userId: string) {
    appServer.setAccessToken(token);
    session$.token.set(token);
    session$.userId.set(userId);
  },
  useCurrentUserId() {
    return useValue(session$.userId);
  },
  useIsAuthenticated() {
    return Boolean(useValue(session$.token));
  },
};
